var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "export-hidden" }, [
      _c(
        "div",
        { staticClass: "export-this p-4" },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center",
              style: { gap: "20px" }
            },
            [
              _c("img", {
                staticClass: "mb-3",
                style: { width: "220px" },
                attrs: { src: "/imgs/logoAbelhaRainha.png" }
              }),
              _vm._v(" "),
              _c("el-card", { staticClass: "mb-3 flex-grow-1" }, [
                _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c(
                        "el-tag",
                        { staticClass: "mr-2", attrs: { type: "info" } },
                        [_c("i", { staticClass: "el-icon-notebook-1" })]
                      ),
                      _vm._v(" "),
                      _vm.userScheduleName
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex align-items-center",
                              style: { gap: "12px" }
                            },
                            [
                              _c(
                                "h5",
                                { staticClass: "mb-0 font-weight-semibold" },
                                [_vm._v("Agenda: ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center",
                                  style: { gap: "4px" }
                                },
                                [
                                  _c(
                                    "el-avatar",
                                    { attrs: { size: "small" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.scheduleUserName.charAt(0))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h6",
                                    { staticClass: "mb-0 text-capitalize" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.scheduleUserName.toLowerCase()
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        : _c(
                            "h5",
                            { staticClass: "font-weight-semibold mb-0" },
                            [_vm._v("Minha Agenda")]
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.date
                    ? _c("h5", { staticClass: "font-weight-semibold mb-0" }, [
                        _vm._v(_vm._s(_vm.date))
                      ])
                    : _vm._e()
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-card",
                    [
                      _vm._t("calendar"),
                      _vm._v(" "),
                      _vm.status.length > 0
                        ? _c(
                            "div",
                            { staticClass: "d-flex align-items-center mt-3" },
                            [
                              _c("h6", { staticClass: "mb-0 mr-2" }, [
                                _vm._v("Status:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center",
                                  style: { gap: "8px" }
                                },
                                _vm._l(_vm.status, function(stat) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: stat.value,
                                      staticClass: "rounded-pill",
                                      attrs: {
                                        type: _vm.getEventColorByStatus(
                                          stat.value
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(stat.text) +
                                          "\n                                "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.despesas.length > 0
                        ? _c(
                            "div",
                            { staticClass: "d-flex align-items-center mt-3" },
                            [
                              _c("h6", { staticClass: "mb-0 mr-2" }, [
                                _vm._v("Despesas:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center",
                                  style: { gap: "8px" }
                                },
                                _vm._l(_vm.despesas, function(des) {
                                  return _c(
                                    "div",
                                    { staticClass: "border rounded py-1 px-2" },
                                    [
                                      _c("i", { class: des.icon }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "ml-1" }, [
                                        _vm._v(_vm._s(des.text))
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-215ebe7e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215ebe7e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/EventsExportToPdf.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-215ebe7e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/EventsExportToPdf.vue
// module chunks = 2